

import ContactUsWrapper from '../ui/ContactUsWrapper.vue'

export default {
  components: { ContactUsWrapper },
  props: {
    section: {
      type: Object,
      required: true
    }
  },

  computed: {

  },
  methods: {

  }
}
